/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/407189/%E6%95%99%E8%82%B2%E5%B1%80%E8%AD%898%E6%A0%A1%E7%B6%B2%E4%B8%8A%E6%A0%A1%E7%AE%A1%E7%B3%BB%E7%B5%B1%E8%A2%AB%E5%85%A5%E4%BE%B5-%E5%96%87%E6%B2%99%E5%B0%8F%E5%AD%B8%E9%80%9A%E7%9F%A5%E5%AE%B6%E9%95%B7%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/news_events/media_statements/press_20130115_4.html'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.881903.com/news/local/2504965/5%E9%96%93%E6%A9%9F%E6%A7%8B%E5%92%8C%E5%AD%B8%E6%A0%A1WhatsApp%E7%BE%A4%E7%B5%84%E9%81%AD%E9%A8%8E%E5%8A%AB-%E8%BF%91900%E4%BA%BA%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9'
          );
        }}
        className="source3"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/407189/%E6%95%99%E8%82%B2%E5%B1%80%E8%AD%898%E6%A0%A1%E7%B6%B2%E4%B8%8A%E6%A0%A1%E7%AE%A1%E7%B3%BB%E7%B5%B1%E8%A2%AB%E5%85%A5%E4%BE%B5-%E5%96%87%E6%B2%99%E5%B0%8F%E5%AD%B8%E9%80%9A%E7%9F%A5%E5%AE%B6%E9%95%B7%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/news_events/media_statements/press_20130115_4.html'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.881903.com/news/local/2504965/5%E9%96%93%E6%A9%9F%E6%A7%8B%E5%92%8C%E5%AD%B8%E6%A0%A1WhatsApp%E7%BE%A4%E7%B5%84%E9%81%AD%E9%A8%8E%E5%8A%AB-%E8%BF%91900%E4%BA%BA%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9'
          );
        }}
        className="source3"
      />
    </div>
  </>
);

export default Components004;
